import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppTranslationModule } from '../app.translation.module';
import { NgaModule } from '../theme/nga.module';

import { routing } from './pages.routing';
import { Pages } from './pages.component';

@NgModule({
	imports: [CommonModule, AppTranslationModule, NgaModule, routing],
	declarations: [Pages]
})

export class PagesModule {}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/pages/pages.module.ts